export enum DetailsMatch {
    ExactMatch = 'exact-match',
    PartialMatch = 'partial-match',
    NoMatch = 'no-match',
}
